import { useNavigate } from "react-router-dom";

const ErrorPage = ({ error, resetError }) => {
  const navigate = useNavigate();
  const isDev = import.meta.env.DEV;

  const errorPageImage =
    "https://placehold.co/1920x1080/fef2f2/ef4444?text=Error!\\nClick+to+go+Home";

  const handleClick = () => {
    if (resetError) {
      resetError();
    }
    navigate("/");
  };

  return (
    <div className="fixed inset-0 w-full h-screen flex flex-col items-center justify-center bg-white p-4 sm:p-8 md:p-12">
      {/* Show error details in development mode */}
      {isDev && error && (
        <div className="w-full max-w-4xl mb-4 p-4 bg-red-50 border border-red-200 rounded-lg overflow-auto max-h-64">
          <h2 className="text-red-800 font-bold mb-2">
            Error Details (Dev Mode):
          </h2>
          <pre className="text-sm text-red-700 whitespace-pre-wrap">
            {error.toString()}
            {error.stack && `\n\nStack:\n${error.stack}`}
          </pre>
        </div>
      )}

      <div
        className="w-full h-full flex items-center justify-center cursor-pointer"
        onClick={handleClick}
        title="Click to return home"
      >
        <img
          src={errorPageImage}
          alt="Error - Click to return home"
          className="w-full h-full object-contain"
        />
      </div>

      <button
        onClick={handleClick}
        className="mt-4 px-6 py-3 bg-[#305669] text-white rounded-lg hover:bg-[#1785A] transition-colors"
      >
        Return to Home
      </button>
    </div>
  );
};

export default ErrorPage;
